import React from "react";
import { H2, P, Checkbox, Stack, Tab } from "@wigxel/react-components";
import { log } from "@wigxel/utils";

const Poll = ({ name, options, answer, onOptionPicked }) => {
  const checked = key => log(answer.key, "The Current Key") === key;

  return (
    <div className="poll__entry bg-white rounded-lg p-5 shadow-lg">
      <Stack>
        <label>
          <P>The Media Awards Prize for:</P>
          <H2>{name}</H2>
        </label>
      </Stack>
      <br />
      <P>Pick a Talent</P>
      <ul className="poll__opts">
        {options.map((opt_string, key) => (
          <li
            key={key}
            className={[checked(key) && "active"]}
            onClick={evt => {
              evt.preventDefault();
              evt.stopPropagation();
              onOptionPicked({ key, answer: opt_string });
            }}
          >
            <Tab>
              <Checkbox readOnly checked={checked(key)} />
              <span className="stretch" />
              <span>{opt_string}</span>
            </Tab>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Poll;
